import { routes } from 'helpers/routes'
import { Breadcrumb } from 'recoils/atoms'

export const BREADCRUMBS_EDIT: Breadcrumb[] = [
  { key: routes.profile.edit.path, label: 'layout:profile.breadcrumb' },
]
